import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from './config.service';
import { ConsultaGerencial, ConsultaGerencialResponse } from '../persistences/consulta-gerencial';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConsultaGerencialService {

  constructor(
    private configService: ConfigService,
    private httpClient: HttpClient
  ) { }

  getAllConsultasGerenciais(): Observable<ConsultaGerencial[]>{
    return this.httpClient.get<ConsultaGerencial[]>(
      this.configService.getEndereco() + "/Business/consultaGerencial/getAllAcessoAcaoConsulta",
      {
        headers: this.configService.getHeaders()
      }
    )
  }

  salvarConsultaGerencial(consultaGerencial: ConsultaGerencial){
    return this.httpClient.post(
      this.configService.getEndereco() + "/Business/consultaGerencial/salvarAcessoAcaoConsulta",
      consultaGerencial,
      {
        headers: this.configService.getHeaders()
      }
    )
  }

  atualizarConsultaGerencial(consultaGerencial: ConsultaGerencial){
    return this.httpClient.put(
      this.configService.getEndereco() + "/Business/consultaGerencial/atualizarAcessoAcaoConsulta",
      consultaGerencial,
      {
        headers: this.configService.getHeaders()
      }
    )
  }

  deletarConsultaGerencial(idConsultaGerencial: string){
    const parametros = new HttpParams().set("idConsultaGerencial", idConsultaGerencial);
    return this.httpClient.delete(
      this.configService.getEndereco() + "/Business/consultaGerencial/deletarAcessoAcaoConsulta",
      {
        headers: this.configService.getHeaders(),
        params: parametros
      }
    )
  }

  getAcessoAcao(cdCliente: number, cdFilial: number, cdAcesso: string){
    return this.httpClient.post<ConsultaGerencialResponse[]>(
      this.configService.getEndereco() + "/Business/getAcessoAcao",
      {
        cdAcesso: cdAcesso,
        limitSql: "500000100",
        listaAcessoAcaoRelFiltro: [
          {
            parametro: "cd_cliente",
            valor: cdCliente
          },
          {
            parametro: "cd_filial",
            valor: cdFilial
          }
        ]
      },
      {
        headers: this.configService.getHeaders()
      }
    )
  }
}
